import { render, staticRenderFns } from "./DataGovEnvironmentalPunishmentTable.vue?vue&type=template&id=5f7acf00"
import script from "./DataGovEnvironmentalPunishmentTable.vue?vue&type=script&lang=js"
export * from "./DataGovEnvironmentalPunishmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports